import { defaultRelevantPatientsFilters } from "./filters";
import { desiredOrderOfStatuses } from "./sort";
export const OOP_MET_STATUS = "oop-met";
export const RELEVANT_PATIENTS_TABLE_CONFIG = "RelevantPatientsTableConfig";
const ESTABLISHED = "established";
const DONE = "done";

export const getRelevantPatientsTableConfigFromLocalStorage = () => {
  const relevantPatientsTableConfig = localStorage.getItem(RELEVANT_PATIENTS_TABLE_CONFIG);
  const formattedStatuses = desiredOrderOfStatuses.map((item) => ({ value: item.value, children: item.text }));
  const defaultStatuses = formattedStatuses.filter((item) => item.value !== DONE && item.value !== ESTABLISHED);
  const defaultRelevantPatientsTableConfig = {
    id: 0,
    filters: {
      ...defaultRelevantPatientsFilters,
      statuses: defaultStatuses
    },
    sorter: {},
    currentPage: 1
  };

  if (!relevantPatientsTableConfig) {
    localStorage.setItem(RELEVANT_PATIENTS_TABLE_CONFIG, JSON.stringify(defaultRelevantPatientsTableConfig));
    return defaultRelevantPatientsTableConfig;
  }

  return JSON.parse(relevantPatientsTableConfig);
};

export const saveRelevantPatientsTableConfigToLocalStorage = (filters) => {
  localStorage.setItem(RELEVANT_PATIENTS_TABLE_CONFIG, JSON.stringify(filters));
};
